import { Checkbox } from 'antd';
import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledCheckbox = styled(Checkbox)`
  &&&& {
    &.ant-checkbox-wrapper {
      ${pickThemeFontStyles('14', '20')};
      align-items: center;

      & .ant-checkbox {
        top: 0;
      }
    }

    .ant-checkbox-inner {
      border-radius: 0.125rem;
    }

    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: ${COLORS.ORANGE_PRIMARY};
        border-color: ${COLORS.ORANGE_PRIMARY};
      }
    }

    .ant-checkbox-checked
      .ant-checkbox-inner::after
      .ant-checkbox-inner:hover
      .ant-checkbox-checked
      .ant-checkbox-inner {
      border-color: ${COLORS.WHITE} !important;
    }

    .ant-checkbox-checked:hover .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${COLORS.ORANGE_PRIMARY};
      border-color: ${COLORS.ORANGE_PRIMARY};
    }

    .ant-checkbox-checked:after {
      border-color: ${COLORS.ORANGE_PRIMARY};
    }

    .ant-checkbox:hover::after {
      border-color: ${COLORS.ORANGE_PRIMARY};
    }

    .ant-checkbox:hover .ant-checkbox-inner {
      border-color: ${COLORS.ORANGE_PRIMARY};
    }

    & .ant-checkbox-inner {
      width: 1.25rem;
      height: 1.25rem;
    }

    & .ant-checkbox-checked .ant-checkbox-inner {
      &::after {
        border-color: ${COLORS.WHITE};
        width: 6.7px;
        height: 11.42px;
      }
    }

    & .ant-checkbox + span {
      padding-right: 1rem;
      padding-left: 1rem;
    }
  }
`;
